<template>
  <md-input
      v-model="modelValue"
      v-on="$listeners"
      @keypress="onKeypress"
      @paste.prevent
      :maxlength="maxlength"
      type="number"
  />
</template>

<script lang="js">
export default {
  name: "NewNumberWings",
  props: {
    value: String,
    maxlength: String,
    withMinusNum: {
      type: Boolean,
      require: false,
      default: false
    }
  },
  data() {
    return {
      count: 1,
      invalidChars : ["e", "+", "E"]
    }
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  },
  methods: {
    onKeypress($event) {
      if (this.withMinusNum) {
        if(this.invalidChars.includes($event.key)){
          $event.preventDefault();
        }
      } else {
        if (/[^\d]/g.test($event.key)) {
          $event.preventDefault();
        }
      }
    },
  },
};
</script>
